import React from "react";

export const Change: React.FunctionComponent = () => (
	<section>
		<h1>Vesetranszplantációs Várólista Fórum - Szeptember 19.</h1>
		<p>Kedves Orvos és Szakdolgozó Kolléga!</p>
		<p>
			Szeretettel meghívjuk 2025 szeptember 19-én a Semmelweis Egyetem
			Sebészeti Transzplantációs és Gasztroenterológiai Klinikán
			megrendezésre kerülő fórumra “Vesetranszplantációs Várólista:
			Információk és tudnivalók” témában.
		</p>
		<p>
			A részletes programot e-mailben juttatjuk el az Ön részére.
			Részvételi szándékát kérjük az alábbi e-mail címen jelezze
			2025.08.19 éjfélig: vesevarolista.bp@semmelweis.hu
		</p>
		<p>Részvételükre feltétlenül számítunk!</p>
		<p>
			Üdvözlettel, <br />
			Budapesti Vesetranszplantációs Várólista Bizottság
		</p>
	</section>
);
